import { BundleResourcesPackage } from "resources/BundleResourcesPackage";
export class FontResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("FontResourcesPackage");
    }
    public get assets_fonts_BebasNeue_Regular_ttf(): FontFace {
        return this.resource<FontFace>("assets/fonts/BebasNeue-Regular.ttf");
    }
    public get assets_fonts_BebasNeuePro_Bold_otf(): any {
        return this.resource<any>("assets/fonts/BebasNeuePro-Bold.otf");
    }
    public get assets_fonts_BebasNeuePro_Regular_otf(): any {
        return this.resource<any>("assets/fonts/BebasNeuePro-Regular.otf");
    }
    public get assets_fonts_BebasNeuePro_SmEBd_otf(): any {
        return this.resource<any>("assets/fonts/BebasNeuePro-SmEBd.otf");
    }
    public get assets_fonts_BebasNeuePro_SmERg_otf(): any {
        return this.resource<any>("assets/fonts/BebasNeuePro-SmERg.otf");
    }
    public get assets_fonts_COMICZ_TTF(): any {
        return this.resource<any>("assets/fonts/COMICZ.TTF");
    }
    public get assets_fonts_GrapeNuts_Regular_ttf(): FontFace {
        return this.resource<FontFace>("assets/fonts/GrapeNuts-Regular.ttf");
    }
}

